import * as React from 'react';
import classNames from 'classnames';
import {Text} from '../Text';
import style from './badge.scss';

export type BadgeType =
  | 'primary'
  | 'lightPrimary'
  | 'darkGrey'
  | 'grey'
  | 'secondary'
  | 'red'
  | 'lightGrey'
  | 'yellow'
  | 'blue';

export interface BadgeProps {
  type?: BadgeType;
  text: string;
  className?: string;
  wrapperComponent?: string | React.ComponentClass;
}

export function Badge({
  type = 'primary',
  text = '',
  className,
  wrapperComponent = 'span',
}: BadgeProps) {
  return (
    <Text
      className={classNames(className, style.badge, style[type])}
      type="badge"
      text={text}
      component={wrapperComponent}
    />
  );
}

export default Badge;
